import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getNewClubRegistration from './GetNewClubRegistrationData';
import getHQNewClubRegistration from './GetHQNewClubRegistrationData';
import getNewClubRegistrationWorkflow from '../GetWorkFlowByIdData';
import putNewClubRegistrationWorkflow from '../PutWorkFlowData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const NewClubRegistrationData = {
  INITIAL_STATE,
  getNewClubRegistration,
  getHQNewClubRegistration,
  getNewClubRegistrationWorkflow,
  putNewClubRegistrationWorkflow
};

export default NewClubRegistrationData;